import type { IAccountClaim } from "@api/models/IClaim";
import CopyPassword from "@core-components/credentials/CopyPassword";
import CopyUsername from "@core-components/credentials/CopyUsername";
import { Group, Stack } from "@mantine/core";
import ContainerText from "@modules/clientDashboard/components/container/ContainerText";

interface ICouponModalBodyProps {
  item: IAccountClaim;
}

const AccountModalBody: React.FC<ICouponModalBodyProps> = ({ item }) => {
  return (
    <Stack className="items-start">
      <ContainerText className="rounded bg-primary-default font-bold">
        Voici les identifiants de ton nouveau compte :
      </ContainerText>
      <Group className="gap-0 xs:gap-5">
        <ContainerText className="!py-2 h-10 rounded bg-primary-default font-bold">
          Identifiant :
        </ContainerText>
        <CopyUsername
          username={item.username}
          className="h-10 rounded bg-primary-default px-2"
        />
      </Group>
      <Group className="gap-0 xs:gap-5">
        <ContainerText className="!py-2 h-10 rounded bg-primary-default font-bold">
          Mot de passe :
        </ContainerText>
        <CopyPassword
          password={item.password}
          className="h-10 rounded bg-primary-default px-2"
        />
      </Group>
    </Stack>
  );
};

export default AccountModalBody;
